export default "__VITE_ASSET__C7dG2XEm__"